'use client';

import Link from 'next/link';
import { useIntl } from 'react-intl';

type ExtendedRecoLinkProps = {
  /**
   * The link to the extended view page
   */
  link: string;
};

export const ExtendedRecoLink = ({ link }: ExtendedRecoLinkProps) => {
  const { formatMessage } = useIntl();
  return (
    <Link href={link} className="inline-flex items-center">
      {formatMessage({
        id: 'extendedRecoLink.title',
        defaultMessage: 'Entdecke mehr interessante Artikel',
      })}
      <span className="icon-emp-arrow-mini-right h-4 w-4" />
    </Link>
  );
};
